import { render, staticRenderFns } from "./subtitlePenilaian.vue?vue&type=template&id=dd7e4524&"
import script from "./subtitlePenilaian.vue?vue&type=script&lang=js&"
export * from "./subtitlePenilaian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports